/**
 * @generated SignedSource<<d56cdfc0cec150f11a71e619a963a684>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackCategory = "ARCHIVED" | "DRAFT" | "FEEDBACK_SENT" | "INBOX" | "NEED_ACTION" | "REQUEST_SENT";
export type FeedbackTypeFilter = "MEETING" | "OTHER" | "THREE_SIXTY";
export type FeedbackListQuery$variables = {
  aboutUserId?: string | null;
  category: FeedbackCategory;
  feedbackType?: FeedbackTypeFilter | null;
  fromUserId?: string | null;
};
export type FeedbackListQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"FeedbackListViewer">;
  };
};
export type FeedbackListQuery = {
  response: FeedbackListQuery$data;
  variables: FeedbackListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aboutUserId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "category"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "feedbackType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fromUserId"
},
v4 = {
  "kind": "Variable",
  "name": "aboutUserId",
  "variableName": "aboutUserId"
},
v5 = {
  "kind": "Variable",
  "name": "category",
  "variableName": "category"
},
v6 = {
  "kind": "Variable",
  "name": "feedbackType",
  "variableName": "feedbackType"
},
v7 = {
  "kind": "Variable",
  "name": "fromUserId",
  "variableName": "fromUserId"
},
v8 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenByUser",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMeetingFeedback",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestCount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseCount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharedWithMe",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isThreeSixtyParent",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAnonymous",
  "storageKey": null
},
v23 = [
  (v11/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "FeedbackNode",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/)
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "FeedbackRecipientNode",
  "kind": "LinkedField",
  "name": "recipients",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": (v23/*: any*/),
      "storageKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "FeedbackRequestNode",
  "kind": "LinkedField",
  "name": "requests",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        (v28/*: any*/)
      ],
      "storageKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "context",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v11/*: any*/),
        (v25/*: any*/),
        (v26/*: any*/),
        (v27/*: any*/),
        (v28/*: any*/),
        (v29/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "relationshipToViewer",
          "storageKey": null
        }
      ],
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v11/*: any*/),
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v11/*: any*/),
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "type": "Note",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emoji",
          "storageKey": null
        },
        (v11/*: any*/)
      ],
      "type": "OtherContext",
      "abstractKey": null
    },
    (v33/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "FeedbackListViewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "FeedbackListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "feedbacks",
            "args": (v8/*: any*/),
            "concreteType": "FeedbackAndRequestsConnection",
            "kind": "LinkedField",
            "name": "feedbackList",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FeedbackAndRequestsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isFeedbackOrRequest"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v24/*: any*/),
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v34/*: any*/)
                        ],
                        "type": "FeedbackNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/),
                          (v20/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasDraftResponse",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "complete",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FeedbackRecordNode",
                            "kind": "LinkedField",
                            "name": "feedbackRecord",
                            "plural": false,
                            "selections": (v23/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FeedbackNode",
                            "kind": "LinkedField",
                            "name": "feedback",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v24/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/),
                              (v34/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "FeedbackRequestNode",
                        "abstractKey": null
                      },
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "feedbacks",
            "args": (v8/*: any*/),
            "filters": [
              "category",
              "feedbackType",
              "aboutUserId",
              "fromUserId"
            ],
            "handle": "connection",
            "key": "FeedbackList_feedbacks",
            "kind": "LinkedHandle",
            "name": "feedbackList"
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fe602d13ce527771731ec922e6ac91b1",
    "id": null,
    "metadata": {},
    "name": "FeedbackListQuery",
    "operationKind": "query",
    "text": "query FeedbackListQuery(\n  $category: FeedbackCategory!\n  $feedbackType: FeedbackTypeFilter\n  $aboutUserId: ID\n  $fromUserId: ID\n) {\n  viewer {\n    ...FeedbackListViewer_lKaQb\n    id\n  }\n}\n\nfragment FeedbackListViewer_lKaQb on Viewer {\n  feedbacks: feedbackList(category: $category, feedbackType: $feedbackType, aboutUserId: $aboutUserId, fromUserId: $fromUserId, first: 25) {\n    edges {\n      node {\n        __typename\n        __isFeedbackOrRequest: __typename\n        ... on FeedbackNode {\n          lastSeenByUser\n          id\n          title\n          type\n          isDraft\n          isMeetingFeedback\n          requestCount\n          responseCount\n          sharedWithMe\n          updatedAt\n          isArchived\n          isThreeSixtyParent\n          isAnonymous\n          parent {\n            id\n          }\n          creator {\n            id\n            email\n            image\n            fullName\n            firstName\n            lastName\n          }\n          recipients {\n            user {\n              id\n            }\n            id\n          }\n          requests {\n            user {\n              id\n              firstName\n            }\n            id\n          }\n          context {\n            __typename\n            ... on User {\n              id\n              email\n              image\n              fullName\n              firstName\n              lastName\n              isGuest\n              relationshipToViewer\n            }\n            ... on Event {\n              id\n              title\n              start\n              end\n            }\n            ... on Note {\n              id\n              title\n              eventStart\n              eventEnd\n              url\n            }\n            ... on OtherContext {\n              name\n              emoji\n              id\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n        ... on FeedbackRequestNode {\n          id\n          isArchived\n          lastSeenByUser\n          hasDraftResponse\n          complete\n          feedbackRecord {\n            id\n          }\n          feedback {\n            id\n            title\n            type\n            isDraft\n            isMeetingFeedback\n            requestCount\n            responseCount\n            sharedWithMe\n            updatedAt\n            isArchived\n            isThreeSixtyParent\n            isAnonymous\n            parent {\n              id\n            }\n            creator {\n              id\n              email\n              image\n              fullName\n              firstName\n              lastName\n            }\n            recipients {\n              user {\n                id\n              }\n              id\n            }\n            requests {\n              user {\n                id\n                firstName\n              }\n              id\n            }\n            context {\n              __typename\n              ... on User {\n                id\n                email\n                image\n                fullName\n                firstName\n                lastName\n                isGuest\n                relationshipToViewer\n              }\n              ... on Event {\n                id\n                title\n                start\n                end\n              }\n              ... on Note {\n                id\n                title\n                eventStart\n                eventEnd\n                url\n              }\n              ... on OtherContext {\n                name\n                emoji\n                id\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "542478c5e1557b63fb1cb69778b5f205";

export default node;
